import { Transition } from "motion";

export class PulseGlow {
    getAnimation() {
        return {
            animate: {
                boxShadow: [
                    "0 0 50px 12px rgba(0,128,0,0.6)",     // green
                    "0 0 100px 24px rgba(0,128,0,0.6)",      // loop back to green
                    "0 0 50px 12px rgba(0,128,0,0.6)",     // green
                    "0 0 100px 24px rgba(0,128,0,0.6)",
                ],
            },
            transition: {
                duration: 4,
                repeat: Infinity,
                ease: "linear",
                repeatType: "reverse",
            } as Transition
        };
    }
}
